module.exports = __webpack_public_path__ + "static/media/reserve.701964ae.svg";